/**
 * Automation New ↔ testing agent (isolated from production studio).
 *
 * This agent is NOT the production Playwright agent on REACT_APP_WS_URL (:3003 /
 * nlp_automation_phase2). Automation New uses REACT_APP_TESTING_AGENT_URL
 * (same host as context / scenario APIs).
 */

export const AUTOMATION_NEW_AGENT_URL =
  process.env.REACT_APP_TESTING_AGENT_URL || 'http://localhost:8000';

export const AUTOMATION_NEW_SOCKET_PATH = '/test-automation/socket.io/';

/** Optional JWT; local agent accepts anonymous when DATABASE_URL is empty. */
export const AUTOMATION_NEW_AGENT_TOKEN =
  process.env.REACT_APP_AUTOMATION_NEW_AGENT_TOKEN || '';

export const RUN_LABEL = {
  IDLE: 'IDLE',
  CONNECTING: 'CONNECTING',
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  ERROR: 'ERROR',
  STOPPED: 'STOPPED',
};
